(function () {
  // Use the SAME variant IDs you put in blocks/_ghost-order-options.liquid
  var ADDON_LABELS = {
    '44151005839677': 'Candle +$69',
    '44151002890557': 'Champagne +$125',
    '44151017767229': 'Chocolate +$35',
    '44156792439101': 'Vase +$35',
  };
  var ADDON_VARIANT_IDS = Object.keys(ADDON_LABELS);

  var syncing = false;

  function isAddon(item) {
    return ADDON_VARIANT_IDS.indexOf(String(item.variant_id)) !== -1;
  }

  function changeLine(line, extra) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ line: line }, extra)),
    }).then(function (r) { return r.json(); });
  }

  async function syncCart(cart) {
    if (syncing || !cart || !cart.items) return;

    // A genuine full cart object (from /cart.js or /cart/change.js) always
    // has cart-level fields like item_count. A raw /cart/add.js response
    // only lists the item(s) just added and lacks these — if we ran our
    // grouping logic against that partial shape, a still-in-progress
    // multi-step add (like ours) could look like "the main product is
    // missing", causing us to wrongly rewrite/remove other line items.
    if (typeof cart.item_count === 'undefined') return;

    var groups = {};
    cart.items.forEach(function (item, idx) {
      var group = item.properties && item.properties._io_order_group;
      if (!group) return;
      groups[group] = groups[group] || [];
      groups[group].push({ item: item, line: idx + 1 });
    });

    var actions = [];

    Object.keys(groups).forEach(function (group) {
      var entries = groups[group];
      var mainEntry = entries.find(function (e) { return !isAddon(e.item); });
      var addonEntries = entries.filter(function (e) { return isAddon(e.item); });

      if (!mainEntry && addonEntries.length) {
        // Main product was removed -> remove its orphaned add-ons too
        addonEntries.forEach(function (e) { actions.push({ line: e.line, quantity: 0 }); });
        return;
      }

      if (mainEntry) {
        // Recalculate "Gift wrapping" from whatever add-ons are still present
        var expected = addonEntries
          .map(function (e) { return ADDON_LABELS[String(e.item.variant_id)]; })
          .filter(Boolean)
          .join(',');
        var current = (mainEntry.item.properties && mainEntry.item.properties['Gift wrapping']) || '';
        if (current !== expected) {
          actions.push({
            line: mainEntry.line,
            properties: Object.assign({}, mainEntry.item.properties, { 'Gift wrapping': expected }),
          });
        }
      }
    });

    if (!actions.length) return;

    // Highest line number first, so removing a line doesn't shift the indices
    // of the actions still queued behind it.
    actions.sort(function (a, b) { return b.line - a.line; });

    syncing = true;
    try {
      for (var i = 0; i < actions.length; i++) {
        await changeLine(actions[i].line, actions[i]);
      }
      window.location.reload();
    } finally {
      syncing = false;
    }
  }

  document.addEventListener('cart:updated', function (event) {
    syncCart(event.detail);
  });
})();